import { render, staticRenderFns } from "./Caregiver.vue?vue&type=template&id=546cfb18&"
import script from "./Caregiver.vue?vue&type=script&lang=js&"
export * from "./Caregiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports